import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export function useTablePreviewFlag(): boolean {
  const user = useUser();
  return useFliptBoolean("snowflake-table-preview", false, user?.email);
}
